import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Select, Checkbox, Col } from 'antd';
import { editGroupModulePermissionsRequest } from '../redux/actions/edit_group_module_permissions.actions';
import { getModulesStructureRequest, filterGroupModules } from '../redux/actions/get_modules_structure.actions';
import GroupModulesOptions from './GroupModulesOptions';

const mapStateToProps = (state) => {
    const { filteredModule, modules } = state.UserManagement.User_group_update;
    return { filteredModule, modules };
}; const
    { Option } = Select;

export default connect(mapStateToProps, null)(class GroupModules extends Component {
    componentDidMount() {
        this.props.dispatch(getModulesStructureRequest(this.props.groupId));
    }

  onChangeModulePermission = event => this.props.dispatch(editGroupModulePermissionsRequest(event.target, 'module'));

  handleChangeModule = value => this.props.dispatch(filterGroupModules(value));

  render() {
      const { filteredModule, modules } = this.props;
      return (
          <Col span={24}>
              <Select
                  showSearch
                  style={{ width: 230, marginBottom: '20px' }}
                  placeholder="Select a module"
                  optionFilterProp="children"
                  onChange={this.handleChangeModule}
              >
                  {modules && modules.map(module => <Option key={module.URL} value={module.displayName}>{module.displayName}</Option>)}
              </Select>
              {filteredModule
                  ? (
                      <Fragment>
                          <span className="left_position_for_checkbox">{`${filteredModule.displayName} Access: `}</span>
                          <Checkbox
                              url={filteredModule.URL}
                              style={{ marginLeft: '10px' }}
                              checked={filteredModule.modulePermissions && !!filteredModule.modulePermissions.permissions.length}
                              onChange={this.onChangeModulePermission}
                          />
                      </Fragment>
                  ) : null}
              <div>{filteredModule ? <GroupModulesOptions /> : null}</div>
          </Col>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_update/components/GroupModules.js